(() => {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner || !window.Shopify?.loadFeatures) return;

  const accept = banner.querySelector('[data-cookie-accept]');
  const reject = banner.querySelector('[data-cookie-reject]');
  const settingsButtons = document.querySelectorAll('[data-cookie-settings]');
  const cookiesHeading = [...document.querySelectorAll('h2')].find(
    (heading) => heading.textContent.trim() === 'PLIKI COOKIES',
  );
  let returnFocus = null;

  if (cookiesHeading) {
    cookiesHeading.id = 'pliki-cookies';
    if (window.location.hash === '#pliki-cookies') cookiesHeading.scrollIntoView();
  }

  const setPending = (pending) => {
    accept.disabled = pending;
    reject.disabled = pending;
  };

  const show = (trigger = null) => {
    returnFocus = trigger;
    banner.hidden = false;
    banner.focus();
  };

  const hide = () => {
    banner.hidden = true;
    setPending(false);
    returnFocus?.focus();
    returnFocus = null;
  };

  const loadPrivacy = (onReady) => {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) {
          setPending(false);
          show(returnFocus);
          console.error('Shopify Customer Privacy API could not be loaded.', error);
          return;
        }
        onReady(window.Shopify.customerPrivacy);
      },
    );
  };

  const submit = (payload) => {
    setPending(true);
    loadPrivacy((privacy) => {
      privacy.setTrackingConsent(payload, (result) => {
        if (result?.error) {
          setPending(false);
          console.error('Cookie consent could not be saved.', result.error);
          return;
        }
        hide();
      });
    });
  };

  accept.addEventListener('click', () => submit({
    analytics: true,
    preferences: true,
    marketing: false,
  }));

  reject.addEventListener('click', () => submit({
    analytics: false,
    preferences: false,
    marketing: false,
  }));

  settingsButtons.forEach((button) => {
    button.addEventListener('click', () => show(button));
  });

  loadPrivacy((privacy) => {
    const consent = privacy.currentVisitorConsent();
    if (consent.analytics === '' || consent.preferences === '') show();
  });
})();
